import { msg } from '@lingui/macro'

import { TFCartOrder } from '~graphql/generated/clientGraphql'
import { isDefined } from '~logic/helpers/isDefined'

/**
 * @returns `isUnderMinimalPrice`: true if `minimalOrderPrice` is defined and not reached
 */
export const validateOrderPrice = (order: Nullable<TFCartOrder>) => {
  if (!order) {
    return {
      isUnderMinimalPrice: true,
      minimalPriceMessage: null,
    }
  }

  const { minimalOrderPrice, minimalOrderPriceRemainder } = order
  const hasMinimalPrice = isDefined(minimalOrderPrice) && minimalOrderPrice.value > 0
  const moreItemsRequired = Boolean(minimalOrderPriceRemainder?.value)

  const isUnderMinimalPrice = hasMinimalPrice && moreItemsRequired

  if (!isUnderMinimalPrice) {
    return {
      isUnderMinimalPrice: false,
      minimalPriceMessage: null,
    }
  }

  const minimalPrice = minimalOrderPrice.formattedValue
  const minimalPriceMessage = msg`Minimum order price is ${minimalPrice}`

  return {
    isUnderMinimalPrice,
    minimalPriceMessage,
  }
}

/**
 * @returns `isCartEmpty`: true if there are no items in the cart
 */
const validateCartEmpty = (order: Nullable<TFCartOrder>) => {
  if (!order) {
    return { isCartEmpty: true }
  }
  const isCartEmpty = order.itemCount === 0

  return { isCartEmpty }
}

/**
 * @returns
 *   - `isCartEmpty`: true if there are no items in the cart
 *   - `isUnderMinimalPrice`: true if `minimalOrderPrice` is defined and not reached
 */
export const validateCartContent = (order: Nullable<TFCartOrder>) => {
  const { isCartEmpty } = validateCartEmpty(order)
  const { isUnderMinimalPrice } = validateOrderPrice(order)

  return {
    isCartEmpty,
    isUnderMinimalPrice,
  }
}
